import { createApi } from "@ametie/vue-muza-use";
import * as Sentry from "@sentry/vue";
import FloatingVue from "floating-vue";
import { createPinia } from "pinia";
import { createApp } from "vue";
import Toast from "vue-toastification";

import App from "./App.vue";
import router from "./router";

import "@/shared/assets/styles/fonts.css";
import "./main.scss";
import "floating-vue/dist/style.css";
import "vue-toastification/dist/index.css";
import { myAxios } from "@/shared/api/axios.ts";
import { useToast } from "@/shared/composables";

const { error } = useToast();
const pinia = createPinia();
const app = createApp(App);
const isSentryEnabled = import.meta.env.VITE_SENTRY_ENABLED?.toUpperCase() === "TRUE";
const sentryDSN = import.meta.env.VITE_SENTRY_DSN;

if (isSentryEnabled) {
  Sentry.init({
    app,
    dsn: sentryDSN,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.3,
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 0.3,
  });
}

app.use(pinia);
app.use(router);
app.use(Toast, {
  maxToasts: 5,
});
app.use(FloatingVue);
// Flag to prevent multiple logout calls

// Setup API client with auth error handling
// setupApiClient({
// onTokenRefreshFailed: () => {
//   // Prevent multiple logout calls during 401 storm
//   if (isLoggingOut) return;
//   isLoggingOut = true;
//
//   // Use authStore.logout() to properly reset all state and redirect
//   const authStore = useAuthStore();
//   authStore.logout().finally(() => {
//     isLoggingOut = false;
//   });
// },
// });

app.use(createApi({
  axios: myAxios,
  onError: (errorMessage) => {
    error(errorMessage.message);
  },
}));

// Mount the app
app.mount("#app");
